import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActionAuctionComponent } from './action-auction.component';
import { SharedModule } from '../../shared/shared.module';
import { IconModule } from 'src/app/directives/icon.module';
import { StopwatchShared } from '../../shared/stopwatch/stopwatch.module';
import { PopupShoppingComponent } from '../../modals/popup-shopping/popup-shopping.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IconModule,
    StopwatchShared,
    MatSelectModule,
    FormsModule,
  ],
  declarations: [ActionAuctionComponent, PopupShoppingComponent],
  exports: [ActionAuctionComponent],
})
export class ActionAuctionShared {}
